import React, { useEffect, useState } from 'react';
// import Link from 'next/link';
// import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import camelcaseKeys from 'camelcase-keys';
import { DateTime } from 'luxon';
import { withIronSession } from 'next-iron-session';
import { Col, Row } from 'react-bootstrap';
import Head from '../components/head';
import Layout from '../components/Layout';
import OpenGraphDescription from '../components/OpenGraphDescription';
import OpenGraphTitle from '../components/OpenGraphTitle';
import Section from '../components/Section';
// import PageTitle from '../components/PageTitle';
// import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
// import BookingSummary from '../components/BookingSummary';
import PhoneLink from '../components/PhoneLink';
// import TipSelection from '../components/TipSelection';
import { FranchiseeProvider } from '../context/Franchisee';
import { FranchiseeState } from '../context/Franchisee/franchisee.types';
import { LeadAppointment, LeadState } from '../context/Lead/lead.types';
import leadSession from '../context/Lead/leadSession';
import { getPackageById } from '../data/cleaningPackages';
import { setResetStore } from '../features/user/userSlice';
import db from '../SDKs/firebase/firebase';
import Gataware from '../SDKs/Gataware';
import leadConfig from '../sessions/lead';
import { updateVonigoCustomClientField } from '../utils/vonigoApiCalls';
import { trackScheduleNow } from '../utils/analytics';
// import SVG from "react-inlinesvg"
export const getServerSideProps = withIronSession(async ({ req, res }) => {
  try {
    const leadId = req.session.get('leadId');
    const franchiseeId =
      req.session.get('franchiseeId') === undefined
        ? 14
        : req.session.get('franchiseeId');
    const cleaningDate = req.session.get('cleaningDate');
    const appointment = req.session.get('appointment');

    const locationsRequest = Gataware.getLocations({
      ids: [franchiseeId],
    }).then(({ data }) => JSON.parse(data));

    const leadRequest = Gataware.lead.checkIfLeadExists({ leadId });

    const [franchiseesResponse, lead] = await Promise.all([
      locationsRequest,
      leadRequest,
    ]);

    const franchisees = franchiseesResponse.data.map((franchisee) =>
      camelcaseKeys(franchisee)
    );

    const [franchisee] = franchisees;

    console.log({ franchisee, lead, appointment });

    return {
      props: {
        franchisee: franchisee ?? {},
        appointment: appointment ?? '',
        lead: lead ?? {},
      },
    };
  } catch (e) {
    // res.setHeader('location', '/book/');
    // res.statusCode = 302;
    // return res.end();
    return {
      props: {
        franchisee: {},
        appointment: '',
        lead: {},
      },
    };
  }
}, leadConfig);

interface ThankYouPageProps {
  /* add thank you page props here */
  franchisee: FranchiseeState;
  lead: LeadState;
  appointment: LeadAppointment;
}

const ThankYou: React.FC<ThankYouPageProps> = ({
  franchisee,
  lead,
  appointment,
}: ThankYouPageProps) => {
  const {
    firstName,
    lastName,
    phonePrimary,
    bedrooms,
    bathrooms,
    people,
    pets,
    squareFootage,
    email,
    addressLineOne,
    addressLineTwo,
    state,
    city,
    zipCode,
    price,
    tax,
    totalPrice,
    watchedVideo,
    serviceFee,
  } = lead;

  const [adjustedTotal, setAdjustedTotal] = useState<number>(0);
  const cleaningDate: DateTime = DateTime.fromISO(lead.dateTime);
  const [selectedPackage, setSelectedPackage] = useState<any>({});
  const [billingAddressLineOne, setBillingAddressLineOne] =
    useState<string>('');
  const [billingAddressLineTwo, setBillingAddressLineTwo] =
    useState<string>('');
  const [billingCity, setBillingCity] = useState<string>('');
  const [billingState, setBillingState] = useState<string>('');
  const [billingZipCode, setBillingZipCode] = useState<string>('');
  const [tips, setTips] = useState<any>(0);
  const [thankYouPageTipInput, setThankYouPageTipInput] = useState<any>(0);
  const [leadPackage, setLeadPackage] = useState<any>(null);
  const [customer, setCustomer] = useState<any>(0);
  const [id, setID] = useState<any>(0);
  const dispatch = useDispatch();
  const recurringPackages = [2,4,5,6,10]

  useEffect(() => {
    setLeadPackage(lead?.package);
    trackScheduleNow({
      phone: lead?.phonePrimary, 
      email: lead?.email, 
      zipCode: lead?.zipCode,
      packageId: lead?.package,
      packagePrice: lead?.price
    })
    leadSession.clear();
    setTimeout(() => {
      const userStatusDatabaseRef = db.ref(`/online/${lead.id}`);
      userStatusDatabaseRef.remove();
    }, 60000);
  }, []);

  useEffect(() => {
    if (typeof totalPrice === 'string') {
      setAdjustedTotal(parseFloat(totalPrice));
    }
  });

  useEffect(() => {
    try {
      db.ref(process.env.kpiDashboardCollectionName + '/' + lead?.id).update({
        step: 7,
      });
    } catch (error) {
      console.log(error);
    }
    try {
      if (!lead?.id) return;
      const userStatusDatabaseRef = db.ref(`/online/${lead?.id}`);

      db.ref('.info/connected').on('value', async (snap) => {
        if (snap.val() === true) {
          await userStatusDatabaseRef.onDisconnect().remove();
          await userStatusDatabaseRef.set({
            leadID: lead?.id,
          });
        } else {
          await userStatusDatabaseRef.remove();
        }
      });
    } catch (error) {
      console.log(error);
    }
  }, []);

  const displayTime = (): string => {
    if (cleaningDate === null) return '';
    if (cleaningDate.hour >= 8 && cleaningDate.hour < 11)
      return 'Morning (8am - 11am)';
    if (cleaningDate.hour >= 11 && cleaningDate.hour < 13)
      return 'Midday (11am - 2pm)';
    if (cleaningDate.hour >= 13) return 'Afternoon (2pm-5pm)';
    return '';
  };

  const packageId =
    typeof lead.package === 'string'
      ? parseInt(lead.package, 10)
      : lead.package;

  useEffect(() => {
    const billingAddressData = axios
      .get('/api/billing-address-session/')
      .then((res) => {
        // console.log(res.data.data.billingAddress);
        if (res.data.data.billingAddress.sameAddress === false) {
          setBillingAddressLineOne(
            res.data.data.billingAddress.billingAddressLineOne
          );
          setBillingAddressLineTwo(
            res.data.data.billingAddress.billingAddressLineTwo
          );

          setBillingCity(res.data.data.billingAddress.billingCity);

          setBillingState(res.data.data.billingAddress.billingState);

          setBillingZipCode(res.data.data.billingAddress.billingZipCode);
        } else {
          setBillingAddressLineOne(addressLineOne);
          setBillingAddressLineTwo(addressLineTwo);
          setBillingCity(city);
          setBillingState(state);
          setBillingZipCode(zipCode);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      // get the data from the api
      const data = await axios.get('/api/tips-session/');
      setTips(data.data.data.tipsData.tips);
      setCustomer(data.data.data.tipsData.customer);
      setID(data.data.data.tipsData.id);
    };

    // call the function
    fetchData()
      // make sure to catch any error
      .catch(console.error);
  }, []);

  const setTipFromThankYou = (val) => {
    setThankYouPageTipInput(val);
  };

  return (
    <FranchiseeProvider franchiseeValue={franchisee}>
      <Layout alternateFooter={true}>
        <Head
          slug='thank-you'
          title='Thank You | Two Maids '
          description='Thank You for booking with Two Maids !'
        />
        <OpenGraphTitle title='Thank You | Two Maids ' />
        <OpenGraphDescription>
          Thank you for booking with Two Maids !
        </OpenGraphDescription>
        <div className='thank-you-hero-container'>
          <img
            className='thank-you-hero-background'
            src='https://res.cloudinary.com/twomaidsengi/image/upload/c_scale,q_44,w_2515/v1670442696/hubsite-reskin/opaque-dots-pink.png'
            alt='Pink opaque dots'
          /> 
          <Section className='thank-you-hero-text-section'>
            <h2 className='h1 mb-3 '>
              Thank You,{' '}
              <span className='text-capitalize'>
                {lead.firstName}
              </span>
            </h2>
            {
              recurringPackages.includes(Number(lead.package)) ? (
                <>
                  <p className='mb-3' style={{fontSize: 'var(--paragraph-text'}}>We&apos;ve scheduled your appointment.</p>
                  <p className='mb-3' style={{fontSize: 'var(--paragraph-text'}}>
                    We strongly recommend your first cleaning service be a Deep Clean Service to thoroughly 
                    rid dust, dirt, and grime that accumulates over time, setting the stage for regular upkeep.
                  </p>

                  <div className='d-lg-flex align-items-center' style={{gap: '1rem'}}>
                    <img 
                      src="https://res.cloudinary.com/twomaidsengi/image/upload/v1744050921/hubsite-reskin/Deep_Clean.svg" 
                      alt="An image"
                      style={{width: '175px'}}
                      className='p-3'
                    />
                    <div>
                      <h3 style={{color: 'var(--dark-pink)', fontFamily: 'Gotham Medium', fontSize: 'var(--paragraph-text'}}>
                        Why Start with a Deep Clean?
                      </h3>
                      <p className='mb-3' style={{fontSize: 'var(--paragraph-text'}}>
                        Maintaining a clean home environment begins with tackling the grime that accumulates over time, 
                        setting the stage for regular recurring cleaning upkeep. Our Deep Cleaning service is designed to 
                        provide just that. As our most thorough house cleaning service available, the biggest difference 
                        between the Deep Cleaning package and our other standard cleaning packages is the amount of time 
                        and detail we spend cleaning what we refer to as your vertical surfaces.
                      </p>
                    </div>
                  </div>

                  <div className='d-lg-flex align-items-center' style={{gap: '1rem'}}>
                    <img 
                      src="https://res.cloudinary.com/twomaidsengi/image/upload/v1744050933/hubsite-reskin/Recurring_Clean_Icon.svg" 
                      alt="An image"
                      style={{width: '175px', height: '175px'}}
                      className='p-3'
                    />
                    <div>
                      <h3 style={{color: 'var(--dark-pink)', fontFamily: 'Gotham Medium', fontSize: 'var(--paragraph-text'}}>
                        Vertical Surfaces
                      </h3>
                      <ul className='mb-3' style={{color: 'var(--grey)'}}>
                        <li>Baseboards</li>
                        <li>Trim work</li>
                        <li>Interior windows &amp; blinds</li>
                        <li>Exterior cabinets &amp; drawers</li>
                        <li>Light Fixtures</li>
                        <li>Doors</li>
                      </ul>
                    </div>
                  </div>

                  <p style={{fontSize: 'var(--paragraph-text'}}>
                    Call us at <PhoneLink number={franchisee.phonePrimary} /> to upgrade this first appointment to a deep clean. 
                    Your satisfaction is our highest priority.
                  </p>
                </>
              ) : (
                <>
                  <p className='mb-3'>We&apos;ve scheduled your appointment!</p>
                  <p className='mb-3'>
                    A local representative will contact you to confirm all details of
                    your appointment. Check your inbox for a confirmation email and
                    our welcome packet.
                  </p>
                  <p className='mb-3'>
                    If you have any questions, feel free to reach us at{' '}
                    <PhoneLink number={franchisee.phonePrimary} />.
                  </p>
                </>
              )
            }
          </Section>
        </div>
        <Section className='booking-input-container'>
          <div className={`book__summary`}>
            <hr />
            <div className='summary-with-order mt-1 mb-1 '>
              <h1
                className='h3 col-md-6 col-sm-12'
                style={{ paddingLeft: '0px' }}
              >
                BOOKING SUMMARY
              </h1>
              {appointment?.id && (
                <h1 className='h3 col-md-6 col-sm-12 booking-order-number'>
                  Order #{appointment.id}
                </h1>
              )}
            </div>
            <hr />
            <Row>
              <Col xs={12} md={6} className='order-1 order-md-0'>
                <p className='lead font-weight-bold'>
                  <span data-summary='package'>
                    {getPackageById(packageId).name}
                  </span>
                </p>
                <p>
                  <span data-summary='squareFootage'>
                    {squareFootage} sq. ft.
                  </span>
                  <br />
                  <span data-summary='bedrooms'>{bedrooms} bedrooms</span>
                  <br />
                  <span data-summary='bathrooms'>{bathrooms} bathrooms</span>
                  <br />
                  <span data-summary='people'>{people} people</span>
                  <br />
                  <span data-summary='pets'>{pets} pets</span>
                </p>
              </Col>
              <Col xs={12} md={6} className='order-0 order-md-1'>
                {/* Add vonigo here */}
                <p className='lead font-weight-bold'>
                  {cleaningDate !== null &&
                    cleaningDate.toFormat('DDDD') !== 'Invalid DateTime' && (
                      <>
                        <span data-summary='appointmentDate'>
                          {cleaningDate.toFormat('DDDD')}
                        </span>

                        <br />
                        <small className='font-weight-bold'>
                          <span
                            data-summary='appointmentTime font-weight-bold'
                            className='appointmentTime'
                          >
                            {displayTime()}
                          </span>
                        </small>
                      </>
                    )}

                </p>
              </Col>
            </Row>
            <hr className='booking-summary-hr' />
          </div>
          {/* <PageTitle className="">Thank You</PageTitle> */}
          {/* Add thank you page content Here */}
          <Row className='mt-2 thank-you-grid'>
            <Col xs={12} md={10} lg={8}>
              <div id='booking-form-confirmation' className='mb-4'>

                <h3>Customer Information</h3>

                <div className='thank-you-address-section'>
                  <div>
                    <p className='lead font-weight-bold form-section-header'>
                      <span data-summary='package'>Contact Information</span>
                    </p>
                    <p>
                      {firstName} {lastName}
                    </p>
                    <p>{phonePrimary}</p>
                    <p>{email}</p>
                  </div>
                  <>
                    <div>
                      <p className='lead font-weight-bold form-section-header'>
                        <span data-summary='package'>Service Address</span>
                      </p>
                      <p>
                        {addressLineOne}, {addressLineTwo && addressLineTwo}{' '}
                      </p>
                      <p>
                        {city}, {state}, {zipCode}
                      </p>
                      <p>United States</p>
                    </div>
                    {billingAddressLineOne && (
                      <div>
                        <p className='lead font-weight-bold form-section-header'>
                          <span data-summary='package'>Billing Address</span>
                        </p>
                        <p>
                          {billingAddressLineOne},{' '}
                          {billingAddressLineTwo && billingAddressLineTwo}
                        </p>
                        <p>
                          {billingCity}, {billingState}, {billingZipCode}
                        </p>
                        <p>United States</p>
                      </div>
                    )}
                  </>
                </div>
              </div>
            </Col>
            <Col className='thank-you-page-card-container'>
              <div className='thank-you-page-card'>
                {lead.totalPrice && (
                  <Col style={{ padding: '1rem 1.5rem' }}>
                    <Row style={{ marginRight: '0' }}>
                      {typeof lead.price === 'string' ? (
                        <Col xs={12} className='d-flex justify-content-between'>
                          <p className='ml-3'>Price:</p>
                          <p>${Number(lead.price).toFixed(2)}</p>
                        </Col>
                      ) : (
                        <Col xs={12} className='d-flex justify-content-between'>
                          <p className='ml-3'>Price:</p>
                          <p>${Number(lead.price).toFixed(2)}</p>
                        </Col>
                      )}
                      {lead.watchedVideo && (
                        <Col xs={12} className='d-flex justify-content-between'>
                          <p className='ml-3'>Discount:</p>
                          <p>-$10.00</p>
                        </Col>
                      )}
                      {lead.serviceFee > 0 && (
                        <>
                          {' '}
                          <Col
                            xs={12}
                            className='d-flex justify-content-between'
                          >
                            <p className='ml-3'>Service Fee:</p>
                            <p>${lead.serviceFee}</p>
                          </Col>
                          <Col className='mb-2'>
                            {' '}
                            <div
                              style={{
                                // padding: '3px 10px',
                                fontSize: '10px',
                                color: '#9e9e9e',
                              }}
                              className='ml-3'
                            >
                              This service fee helps us operate Two Maids.
                            </div>
                          </Col>
                        </>
                      )}{' '}
                      {(tips > 0 || lead.tip > 0) && (
                        <Col xs={12} className='d-flex justify-content-between'>
                          <p className='ml-3'>Tip:</p>
                          <p>${tips > 0 ? tips : lead.tip}</p>
                        </Col>
                      )}
                      {Number(tax) > 0 && (
                        <>
                          <Col
                            xs={12}
                            className='d-flex justify-content-between'
                          >
                            <p className='ml-3'>Estimated Tax:</p>
                            <p>$ {Number(tax).toFixed(2)}</p>
                          </Col>
                          <Col className='mb-2'>
                            {' '}
                            <div
                              style={{
                                // padding: '3px 10px',
                                fontSize: '10px',
                                color: '#9e9e9e',
                              }}
                              className='ml-3'
                            >
                              Finalized tax will be shown on your order receipt.
                            </div>
                          </Col>
                        </>
                      )}
                      <Col
                        xs={12}
                        className='d-flex justify-content-between border-top border-gray'
                        style={{ paddingTop: '1rem' }}
                      >
                        <p className='ml-3'>Total:</p>
                        <p>
                          $
                          {lead.tip == 0 && tips > 0
                            ? (Number(lead.totalPrice) + Number(tips)).toFixed(
                                2
                              )
                            : Number(lead.totalPrice).toFixed(2)}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                )}
              </div>
            </Col>
          </Row>
        </Section>
      </Layout>
    </FranchiseeProvider>
  );
};

export default ThankYou;
